(function () {
  'use strict';

  function initSiteChrome() {
    var header = document.querySelector('[data-amour-site-header]');
    if (!header || header.dataset.amourReady === 'true') return;
    header.dataset.amourReady = 'true';

    var menu = header.querySelector('[data-amour-menu]');
    var overlay = header.querySelector('[data-amour-menu-overlay]');
    var menuToggle = header.querySelector('[data-amour-menu-toggle]');
    var menuClose = header.querySelector('[data-amour-menu-close]');
    var announcement = header.querySelector('[data-amour-announcement]');
    var announcementClose = header.querySelector('[data-amour-announcement-close]');
    var announcementSource = header.querySelector('[data-amour-announcement-source]');
    var announcementText = header.querySelector('[data-amour-announcement-text]');
    var announcementLink = header.querySelector('[data-amour-announcement-link]');
    var announcementPrevious = header.querySelector('[data-amour-announcement-previous]');
    var announcementNext = header.querySelector('[data-amour-announcement-next]');
    var announcementIconOptions = header.querySelectorAll('[data-amour-announcement-icon-key]');
    var searchToggles = header.querySelectorAll('[data-search-mobile-toggle]');
    var cartToggles = header.querySelectorAll('.amour-site-header__cart');
    var cartCloseButtons = header.querySelectorAll('#dropdown-cart .close-cart');
    var globalOverlay = document.querySelector('.wrapper-overlay');
    var desktopHeader = header.querySelector('[data-amour-desktop-header]');
    var desktopTriggers = header.querySelectorAll('[data-amour-desktop-trigger]');
    var desktopDropdowns = header.querySelectorAll('[data-amour-desktop-dropdown]');
    var desktopSearchToggle = header.querySelector('[data-amour-desktop-search-toggle]');
    var desktopSearchForm = header.querySelector('[data-amour-desktop-search-form]');
    var desktopSearchInput = header.querySelector('[data-amour-desktop-search-input]');
    var localizationToggles = header.querySelectorAll('[data-amour-localization-toggle]');
    var localizationPanels = header.querySelectorAll('[data-amour-localization-panel]');
    var menuPanels = menu ? menu.querySelectorAll('[data-amour-menu-panel]') : [];
    var submenuTriggers = menu ? menu.querySelectorAll('[data-amour-submenu-trigger]') : [];
    var submenuBackButtons = menu ? menu.querySelectorAll('[data-amour-menu-back]') : [];
    var activeMenuPanel = 'main';
    var activeSubmenuTrigger = null;
    var lastFocused = null;
    var submenuHistoryActive = false;
    var suppressNextMenuPop = false;
    var activeDesktopDropdown = null;
    var desktopCloseTimer = null;
    var suppressDesktopFocusOpen = false;
    var activeLocalizationToggle = null;
    var activeLanguageDialog = null;

    function setMenuFocusOrigin(origin) {
      if (menu) menu.dataset.amourFocusOrigin = origin;
    }

    function updateHeaderHeight() {
      var headerBounds = header.getBoundingClientRect();
      document.documentElement.style.setProperty('--amour-chrome-header-height', Math.ceil(headerBounds.height) + 'px');
      var viewport = window.visualViewport;
      var visibleHeight = viewport ? viewport.height : window.innerHeight;
      var visibleTop = viewport ? viewport.offsetTop : 0;
      var menuTop = menu && !menu.hidden ? menu.getBoundingClientRect().top : headerBounds.bottom;
      document.documentElement.style.setProperty('--amour-visible-height', visibleHeight + 'px');
      document.documentElement.style.setProperty('--amour-visible-center', (visibleTop + visibleHeight / 2) + 'px');
      document.documentElement.style.setProperty('--amour-menu-available-height', Math.max(0, visibleTop + visibleHeight - menuTop) + 'px');
      if (activeLanguageDialog && window.matchMedia('(min-width: 900px)').matches) activeLanguageDialog.close();
    }

    function focusableItems() {
      if (!menu) return [];
      return Array.prototype.slice.call(menu.querySelectorAll('a[href], button:not([disabled]), summary, select:not([disabled]), input:not([disabled])')).filter(function (item) {
        return item.offsetParent !== null;
      });
    }

    function showMenuPanel(panelName, returnToTrigger) {
      if (!menu) return;
      var previousTrigger = activeSubmenuTrigger;
      var nextPanel = null;

      Array.prototype.forEach.call(menuPanels, function (panel) {
        var isTarget = panel.dataset.amourMenuPanel === panelName;
        panel.hidden = !isTarget;
        if (isTarget) { nextPanel = panel; panel.scrollTop = 0; }
      });

      Array.prototype.forEach.call(submenuTriggers, function (trigger) {
        trigger.setAttribute('aria-expanded', trigger === activeSubmenuTrigger && panelName !== 'main' ? 'true' : 'false');
      });

      activeMenuPanel = panelName;
      menu.dataset.amourActivePanel = panelName;
      if (panelName === 'main') activeSubmenuTrigger = null;

      var menuScroller = menu.querySelector('.amour-site-menu__scroll');
      if (menuScroller) menuScroller.scrollTop = 0;

      requestAnimationFrame(function () {
        if (panelName === 'main') {
          if (returnToTrigger && previousTrigger && typeof previousTrigger.focus === 'function') previousTrigger.focus();
          return;
        }
        var backButton = nextPanel ? nextPanel.querySelector('[data-amour-menu-back]') : null;
        if (backButton) backButton.focus();
      });
    }

    function resetMenuPanel() {
      activeMenuPanel = 'main';
      if (menu) menu.dataset.amourActivePanel = 'main';
      activeSubmenuTrigger = null;
      Array.prototype.forEach.call(menuPanels, function (panel) {
        panel.hidden = panel.dataset.amourMenuPanel !== 'main';
        panel.scrollTop = 0;
      });
      Array.prototype.forEach.call(submenuTriggers, function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
      var menuScroller = menu ? menu.querySelector('.amour-site-menu__scroll') : null;
      if (menuScroller) menuScroller.scrollTop = 0;
    }

    function openMenu() {
      if (!menu || !overlay || !menuToggle) return;
      lastFocused = document.activeElement;
      resetMenuPanel();
      menu.hidden = false;
      overlay.hidden = false;
      updateHeaderHeight();
      menu.scrollTop = 0;
      var menuScroller = menu.querySelector('.amour-site-menu__scroll');
      if (menuScroller) menuScroller.scrollTop = 0;
      menuToggle.setAttribute('aria-expanded', 'true');
      menuToggle.setAttribute('aria-label', menuToggle.dataset.closeLabel || menuToggle.getAttribute('aria-label'));
      document.body.classList.add('amour-menu-open');
      requestAnimationFrame(function () {
        var items = focusableItems();
        if (items.length) items[0].focus();
      });
    }

    function clearSubmenuHistory() {
      if (!submenuHistoryActive) return;
      submenuHistoryActive = false;
      suppressNextMenuPop = true;
      window.history.back();
      window.setTimeout(function () { suppressNextMenuPop = false; }, 80);
    }

    function closeMenu(returnFocus, preserveHistory) {
      if (!menu || !overlay || !menuToggle) return;
      if (activeLanguageDialog) activeLanguageDialog.close();
      if (!preserveHistory) clearSubmenuHistory();
      menu.hidden = true;
      overlay.hidden = true;
      resetMenuPanel();
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.setAttribute('aria-label', menuToggle.dataset.openLabel || menuToggle.getAttribute('aria-label'));
      document.body.classList.remove('amour-menu-open');
      if (returnFocus !== false && lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    if (menuToggle) {
      menuToggle.addEventListener('pointerdown', function () { setMenuFocusOrigin('pointer'); });
      menuToggle.addEventListener('click', function () {
        if (menu.hidden) openMenu(); else closeMenu(true);
      });
    }
    if (menuClose) menuClose.addEventListener('click', function () { closeMenu(true); });

    Array.prototype.forEach.call(submenuTriggers, function (trigger) {
      trigger.addEventListener('click', function () {
        activeSubmenuTrigger = trigger;
        showMenuPanel(trigger.dataset.amourSubmenuTrigger, false);
        trigger.setAttribute('aria-expanded', 'true');
        if (!submenuHistoryActive) {
          try {
            window.history.pushState({ amourMobileMenu: true, panel: trigger.dataset.amourSubmenuTrigger }, '', window.location.href);
            submenuHistoryActive = true;
          } catch (error) {}
        }
      });
    });

    Array.prototype.forEach.call(submenuBackButtons, function (backButton) {
      backButton.addEventListener('click', function () {
        if (submenuHistoryActive) window.history.back();
        else showMenuPanel('main', true);
      });
    });

    window.addEventListener('popstate', function () {
      if (suppressNextMenuPop) {
        suppressNextMenuPop = false;
        return;
      }
      if (!menu || menu.hidden) {
        submenuHistoryActive = false;
        return;
      }
      if (activeMenuPanel !== 'main') {
        submenuHistoryActive = false;
        showMenuPanel('main', true);
      }
    });

    if (overlay) overlay.addEventListener('click', function () { closeMenu(true); });

    Array.prototype.forEach.call(searchToggles, function (searchToggle) {
      searchToggle.addEventListener('click', function () {
        window.setTimeout(function () {
          var searchInput = header.querySelector('.search-form input[type="search"], .search-form input[name="q"]');
          if (searchInput && document.documentElement.classList.contains('search-open')) searchInput.focus();
        }, 50);
      });
    });

    function closeLocalization(returnFocus) {
      if (!activeLocalizationToggle) return;
      Array.prototype.forEach.call(localizationToggles, function (toggle) { toggle.setAttribute('aria-expanded', 'false'); });
      Array.prototype.forEach.call(localizationPanels, function (panel) { panel.hidden = true; });
      var previousToggle = activeLocalizationToggle;
      activeLocalizationToggle = null;
      if (returnFocus && previousToggle && typeof previousToggle.focus === 'function') previousToggle.focus();
    }

    function openLocalization(toggle) {
      if (!toggle || !window.matchMedia('(min-width: 900px)').matches) return;
      var panelName = toggle.dataset.amourLocalizationToggle;
      closeDesktopDropdown(false);
      closeDesktopSearch(false);
      closeCart();
      activeLocalizationToggle = toggle;
      Array.prototype.forEach.call(localizationToggles, function (item) {
        item.setAttribute('aria-expanded', item === toggle ? 'true' : 'false');
      });
      Array.prototype.forEach.call(localizationPanels, function (panel) {
        panel.hidden = panel.dataset.amourLocalizationPanel !== panelName;
      });
    }

    Array.prototype.forEach.call(localizationToggles, function (toggle) {
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        if (activeLocalizationToggle === toggle) closeLocalization(false);
        else openLocalization(toggle);
      });
    });

    function closeDesktopSearch(returnFocus) {
      if (!desktopHeader || desktopHeader.dataset.amourSearchOpen !== 'true') return;
      desktopHeader.removeAttribute('data-amour-search-open');
      if (desktopSearchForm) desktopSearchForm.hidden = true;
      if (desktopSearchToggle) desktopSearchToggle.setAttribute('aria-expanded', 'false');
      if (returnFocus && desktopSearchToggle && typeof desktopSearchToggle.focus === 'function') desktopSearchToggle.focus();
    }

    function openDesktopSearch() {
      if (!desktopHeader || !desktopSearchForm || !window.matchMedia('(min-width: 900px)').matches) return;
      closeDesktopDropdown(false);
      closeLocalization(false);
      closeCart();
      desktopHeader.dataset.amourSearchOpen = 'true';
      desktopSearchForm.hidden = false;
      if (desktopSearchToggle) desktopSearchToggle.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(function () {
        if (desktopSearchInput) desktopSearchInput.focus();
      });
    }

    if (desktopSearchToggle) {
      desktopSearchToggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        document.documentElement.classList.remove('search-open');
        if (desktopHeader && desktopHeader.dataset.amourSearchOpen === 'true') closeDesktopSearch(false);
        else openDesktopSearch();
      });
    }

    Array.prototype.forEach.call(cartToggles, function (cartToggle) {
      cartToggle.addEventListener('click', function (event) {
        event.preventDefault();
        closeMenu(false);
        closeDesktopDropdown(false);
        closeDesktopSearch(false);
        closeLocalization(false);
        document.documentElement.classList.add('cart-show');
      });
    });

    function closeCart() {
      document.documentElement.classList.remove('cart-show');
    }

    Array.prototype.forEach.call(cartCloseButtons, function (cartCloseButton) {
      cartCloseButton.addEventListener('click', function (event) {
        event.preventDefault();
        closeCart();
      });
    });

    if (globalOverlay) {
      globalOverlay.addEventListener('click', function () {
        if (document.documentElement.classList.contains('cart-show')) closeCart();
      });
    }

    function closeDesktopDropdown(returnFocus) {
      if (!activeDesktopDropdown) return;
      var activeTrigger = header.querySelector('[data-amour-desktop-trigger="' + activeDesktopDropdown + '"]');
      Array.prototype.forEach.call(desktopDropdowns, function (dropdown) { dropdown.hidden = true; });
      Array.prototype.forEach.call(desktopTriggers, function (trigger) { trigger.setAttribute('aria-expanded', 'false'); });
      activeDesktopDropdown = null;
      header.removeAttribute('data-amour-desktop-open');
      if (returnFocus && activeTrigger && typeof activeTrigger.focus === 'function') {
        suppressDesktopFocusOpen = true;
        activeTrigger.focus();
        window.setTimeout(function () { suppressDesktopFocusOpen = false; }, 0);
      }
    }

    function openDesktopDropdown(name) {
      if (!window.matchMedia('(min-width: 900px)').matches) return;
      window.clearTimeout(desktopCloseTimer);
      closeDesktopSearch(false);
      closeLocalization(false);
      closeCart();
      activeDesktopDropdown = name;
      header.dataset.amourDesktopOpen = name;
      Array.prototype.forEach.call(desktopDropdowns, function (dropdown) {
        dropdown.hidden = dropdown.dataset.amourDesktopDropdown !== name;
      });
      Array.prototype.forEach.call(desktopTriggers, function (trigger) {
        trigger.setAttribute('aria-expanded', trigger.dataset.amourDesktopTrigger === name ? 'true' : 'false');
      });
      updateHeaderHeight();
    }

    Array.prototype.forEach.call(desktopTriggers, function (trigger) {
      trigger.addEventListener('pointerenter', function () { openDesktopDropdown(trigger.dataset.amourDesktopTrigger); });
      trigger.addEventListener('focus', function () {
        if (!suppressDesktopFocusOpen) openDesktopDropdown(trigger.dataset.amourDesktopTrigger);
      });
      trigger.addEventListener('click', function () {
        var name = trigger.dataset.amourDesktopTrigger;
        openDesktopDropdown(name);
      });
    });

    if (desktopHeader) {
      header.addEventListener('pointerenter', function () { window.clearTimeout(desktopCloseTimer); });
      header.addEventListener('pointerleave', function () {
        desktopCloseTimer = window.setTimeout(function () {
          if (!header.contains(document.activeElement)) closeDesktopDropdown(false);
        }, 110);
      });
    }

    Array.prototype.forEach.call(desktopDropdowns, function (dropdown) {
      dropdown.addEventListener('click', function (event) {
        if (event.target.closest('a[href]')) closeDesktopDropdown(false);
      });
    });

    document.addEventListener('pointerdown', function (event) {
      if (activeDesktopDropdown && !header.contains(event.target)) closeDesktopDropdown(false);
      if (activeLocalizationToggle && !event.target.closest('[data-amour-localization]')) closeLocalization(false);
      if (desktopHeader && desktopHeader.dataset.amourSearchOpen === 'true' && !event.target.closest('[data-amour-desktop-header]')) closeDesktopSearch(false);
    });

    if (menu) {
      menu.addEventListener('pointerdown', function () { setMenuFocusOrigin('pointer'); });
      menu.addEventListener('click', function (event) {
        if (event.target.closest('[data-amour-menu-link]')) closeMenu(false, true);
      });
    }

    document.addEventListener('keydown', function (event) {
      // The native modal owns focus and Escape while language choices are open.
      if (activeLanguageDialog) {
        if (event.key === 'Escape') {
          event.preventDefault();
          activeLanguageDialog.close();
        } else if (event.key === 'Tab') {
          var dialogItems = activeLanguageDialog.querySelectorAll('button:not([disabled])');
          var firstDialogItem = dialogItems[0];
          var lastDialogItem = dialogItems[dialogItems.length - 1];
          if (event.shiftKey && document.activeElement === firstDialogItem) {
            event.preventDefault();
            lastDialogItem.focus();
          } else if (!event.shiftKey && document.activeElement === lastDialogItem) {
            event.preventDefault();
            firstDialogItem.focus();
          }
        }
        return;
      }
      if (event.key === 'Tab' || event.key === 'Enter' || event.key === ' ') setMenuFocusOrigin('keyboard');
      if (event.key === 'Escape' && activeLocalizationToggle) {
        event.preventDefault();
        closeLocalization(true);
        return;
      }
      if (event.key === 'Escape' && desktopHeader && desktopHeader.dataset.amourSearchOpen === 'true') {
        event.preventDefault();
        closeDesktopSearch(true);
        return;
      }
      if (event.key === 'Escape' && activeDesktopDropdown) {
        event.preventDefault();
        closeDesktopDropdown(true);
        return;
      }
      if (event.key === 'Escape' && document.documentElement.classList.contains('cart-show')) {
        event.preventDefault();
        closeCart();
        return;
      }
      if (!menu || menu.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        if (activeMenuPanel !== 'main') {
          if (submenuHistoryActive) window.history.back();
          else showMenuPanel('main', true);
          return;
        }
        closeMenu(true);
        return;
      }
      if (event.key !== 'Tab') return;
      var items = focusableItems();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (announcement && announcementText && announcementLink && announcementSource) {
      var rawAnnouncementMessages = announcementSource.textContent || '';
      var isDemiFineTemplate = announcement.dataset.amourDemiFine === 'true';
      var premiumOnlyMessage = /(free resizing|lifetime warranty|lifetime guarantee|free fedex shipping|30%\s*off|€\s*100|100\s*€)/i;
      var announcementMessages = rawAnnouncementMessages.split(/\r?\n/).map(function (line) {
        var parts = line.trim().split('~');
        var text = (parts.shift() || '').trim();
        var searchableText = text.toLowerCase();
        var icon = 'assurance';
        if (/klarna|pay later|payment/.test(searchableText)) icon = 'payment';
        else if (/shipping|delivery|fedex/.test(searchableText)) icon = 'shipping';
        else if (/return/.test(searchableText)) icon = 'returns';
        return {
          text: text,
          mobileText: text.replace(/^[\s🌸]+/u, ''),
          url: (parts.join('~') || '#').trim() || '#',
          icon: icon
        };
      }).filter(function (message) {
        return message.text && (!isDemiFineTemplate || !premiumOnlyMessage.test(message.text));
      });
      var announcementIndex = 0;
      var announcementTimer = null;
      var announcementInterval = parseInt(announcement.dataset.amourAnnouncementInterval, 10) || 4000;

      function showAnnouncementMessage(index, animate) {
        if (!announcementMessages.length) return;
        var message = announcementMessages[index % announcementMessages.length];
        var applyMessage = function () {
          announcementText.textContent = window.matchMedia('(max-width: 767px)').matches ? message.mobileText : message.text;
          announcementLink.href = message.url;
          Array.prototype.forEach.call(announcementIconOptions, function (iconOption) {
            iconOption.hidden = iconOption.dataset.amourAnnouncementIconKey !== message.icon;
          });
          announcementText.style.opacity = '1';
        };
        if (animate) {
          announcementText.style.opacity = '0';
          window.setTimeout(applyMessage, 400);
        } else {
          applyMessage();
        }
      }

      function selectAnnouncement(offset) {
        if (!announcementMessages.length) return;
        var currentIndex = (announcementIndex - 1 + announcementMessages.length) % announcementMessages.length;
        var targetIndex = (currentIndex + offset + announcementMessages.length) % announcementMessages.length;
        showAnnouncementMessage(targetIndex, true);
        announcementIndex = (targetIndex + 1) % announcementMessages.length;
      }

      if (announcementMessages.length) {
        showAnnouncementMessage(announcementIndex, false);
        announcementIndex = (announcementIndex + 1) % announcementMessages.length;
        if (announcementMessages.length > 1) {
          announcementTimer = window.setInterval(function () {
            showAnnouncementMessage(announcementIndex, true);
            announcementIndex = (announcementIndex + 1) % announcementMessages.length;
          }, announcementInterval);
        }
      }

      if (announcementPrevious) announcementPrevious.addEventListener('click', function () { selectAnnouncement(-1); });
      if (announcementNext) announcementNext.addEventListener('click', function () { selectAnnouncement(1); });

      var announcementDismissalKey = announcement.dataset.amourClearance === 'true' ? 'amourClearanceAnnouncementDismissed' : 'amourAnnouncementDismissed';
      try {
        if (sessionStorage.getItem(announcementDismissalKey) === 'true') announcement.hidden = true;
      } catch (error) {}
      if (announcementClose) {
        announcementClose.addEventListener('click', function () {
          announcement.hidden = true;
          if (announcementTimer) window.clearInterval(announcementTimer);
          try { sessionStorage.setItem(announcementDismissalKey, 'true'); } catch (error) {}
          updateHeaderHeight();
        });
      }
    }

    document.querySelectorAll('.amour-language-picker').forEach(function (picker) {
      var summary = picker.querySelector('summary');
      var choices = picker.querySelector('.amour-language-picker__choices');
      var form = picker.closest('form');
      var dialog = document.createElement('dialog');
      if (!summary || !choices || !form || typeof dialog.showModal !== 'function') return;
      dialog.className = 'amour-language-dialog notranslate';
      dialog.setAttribute('translate', 'no');
      dialog.id = form.id + '-dialog';
      var heading = document.createElement('div');
      heading.className = 'amour-language-dialog__header';
      var title = document.createElement('h2');
      title.id = dialog.id + '-title';
      title.textContent = picker.querySelector('.amour-language-picker__label').textContent;
      dialog.setAttribute('aria-labelledby', title.id);
      var closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.className = 'amour-language-dialog__close';
      closeButton.setAttribute('aria-label', picker.dataset.closeLabel || 'Close');
      closeButton.textContent = '×';
      heading.appendChild(title);
      heading.appendChild(closeButton);
      dialog.appendChild(heading);
      dialog.appendChild(choices);
      form.appendChild(dialog);
      summary.setAttribute('aria-haspopup', 'dialog');
      summary.setAttribute('aria-controls', dialog.id);
      summary.setAttribute('aria-expanded', 'false');
      summary.addEventListener('click', function (event) {
        event.preventDefault();
        picker.open = false;
        updateHeaderHeight();
        activeLanguageDialog = dialog;
        summary.setAttribute('aria-expanded', 'true');
        dialog.showModal();
        choices.scrollTop = 0;
        closeButton.focus({ preventScroll: true });
      });
      closeButton.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('cancel', function (event) { event.preventDefault(); dialog.close(); });
      dialog.addEventListener('click', function (event) {
        var bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
      });
      dialog.addEventListener('close', function () {
        if (activeLanguageDialog === dialog) activeLanguageDialog = null;
        summary.setAttribute('aria-expanded', 'false');
        summary.focus({ preventScroll: true });
      });
    });

    document.querySelectorAll('[data-amour-localization-select]').forEach(function (select) {
      if (select.dataset.amourSelectReady === 'true') return;
      select.dataset.amourSelectReady = 'true';
      select.addEventListener('change', function () {
        if (!select.form) return;
        if (typeof select.form.requestSubmit === 'function') select.form.requestSubmit();
        else select.form.submit();
      });
    });

    document.querySelectorAll('[data-amour-footer-accordion]').forEach(function (details) {
      if (details.dataset.amourAccordionReady === 'true') return;
      details.dataset.amourAccordionReady = 'true';
      var summary = details.querySelector('summary');
      if (!summary) return;
      function syncFooterAccordionState() {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      }
      syncFooterAccordionState();
      details.addEventListener('toggle', syncFooterAccordionState);
    });

    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateHeaderHeight, { passive: true });
      window.visualViewport.addEventListener('scroll', updateHeaderHeight, { passive: true });
    }
    if (window.ResizeObserver) new ResizeObserver(updateHeaderHeight).observe(header);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSiteChrome);
  else initSiteChrome();
  document.addEventListener('shopify:section:load', initSiteChrome);
})();
